export const dev_mode = false;
const config = {
  API: dev_mode ? "http://localhost:1000/api" : "https://chiorio.voroninlab.ru/api",
};

export default config;
